import axios from 'axios';
import { SHUTTLE_SERVICE_ENDPOINTS } from './shuttle.service.config';
import { GetShuttleDetailsReqParams, GetShuttleRoutesReqParams } from './shuttle.service.type';
import { ShuttleDetails, ShuttleRoute } from '../../domain/shuttle';

const axiosInstance = axios.create();

export class ShuttleService {
  private readonly _endpoints: typeof SHUTTLE_SERVICE_ENDPOINTS;

  constructor() {
    this._endpoints = { ...SHUTTLE_SERVICE_ENDPOINTS };
  }

  public async getShuttleLocations(): Promise<Record<string, number>> {
    return (await axiosInstance.get(this._endpoints.getShuttleLocations)).data.data;
  }

  public async getShuttleRoutes(params: GetShuttleRoutesReqParams): Promise<ShuttleRoute[]> {
    return (await axiosInstance.get(this._endpoints.getShuttleRoutes, { params })).data.data;
  }

  public async getShuttleDetails(params: GetShuttleDetailsReqParams): Promise<ShuttleDetails> {
    return (await axiosInstance.get(this._endpoints.getShuttleDetails, { params })).data.data;
  }
}
